var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c(
            "w-card-title",
            [
              _vm._v(" " + _vm._s(_vm.$ct("views")) + " "),
              _c("w-spacer"),
              _c(
                "w-link",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("common.close"),
                      expression: "$ct('common.close')",
                    },
                  ],
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          ),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-list" } },
            [
              _vm.views.length == 0
                ? _c(
                    "w-list-item",
                    [
                      _c("w-list-item-text", [
                        _vm._v(_vm._s(_vm.$ct("no-views-available"))),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._l(_vm.views, function (view) {
                return _c(
                  "w-list-item",
                  { key: view.ID },
                  [
                    _c("w-list-item-text", [_vm._v(_vm._s(view.Name))]),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("edit-view"),
                                expression: "$ct('edit-view')",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.editView(view)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "pen" } })],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("delete-view"),
                                expression: "$ct('delete-view')",
                              },
                            ],
                            staticClass: "danger",
                            on: {
                              click: function ($event) {
                                return _vm.deleteView(view)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "trash" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c(
                "w-list-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.createView()
                    },
                  },
                },
                [
                  _c(
                    "w-list-item-icon",
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  ),
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.$ct("create-view"))),
                  ]),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "w-modal",
            { attrs: { value: _vm.toEditView != null } },
            [
              _vm.toEditView
                ? _c("app-mongo-view-edit", {
                    attrs: {
                      view: _vm.toEditView,
                      "available-columns": _vm.availableColumns,
                      "supplier-filter": "",
                    },
                    on: {
                      close: function ($event) {
                        return _vm.onViewEditClose()
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }